import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { validateFields, validateField } from '../../../../utilities/validation/validator';
import { regexPatterns } from '../../../../utilities/validation/validationVariables';
import ProviderManager from '../../../../provider/providerManager';
import lodash from 'lodash';

export const getPhoneNumbers = createAsyncThunk('choseNewOrExistingCellNum/getPhoneNumbers', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getPhoneNumbers', [
      data.regularNumbersCount,
      data.prettyNumbersCount,
    ]);
    return result.Body;
  } catch (error) {
    return error;
  }
});

export const getUniqePhoneNumber = (existPhones, newPhones) => {
  let result = '';
  let arrExistPhones = lodash.cloneDeep(existPhones);
  let arrNewPhones = lodash.cloneDeep(newPhones);

  for (let i = 0; i < arrExistPhones.length; i++) {
    if (result != '') break;

    for (let j = 0; j < newPhones.length; j++) {
      if (arrExistPhones[i] != newPhones[j]) {
        result = newPhones[j];
        break;
      }
    }
  }

  return result;
};

const ChoseNewOrExistingCellNumSlice = createSlice({
  name: 'choseNewOrExistingCellNum',
  initialState: {
    form: {
      numOfAttempts: 0,
      isExistPhone: false,
      isSelectedOption: false,
      currentPhone: '',
      hstPhone: '',
      valid: '',
      errors: {},
      errorObj: null,
      selectedPhone: '',
      prevHstPhones: [],
      newPhones: [],
      newPrettyPhones: [],
      isPrettyNum: false,
      rules: {
        currentPhone: {
          required: { value: true, error: 'אנא הכנס מספר טלפון' },
          pattern: { value: regexPatterns.phoneRegex, error: 'יש להכניס מספר ללא תווים נוספים' },
          minLength: { value: 9, error: 'חובה להזין מספר טלפון תקין' },
          maxLength: { value: 10, error: 'חובה להזין מספר טלפון תקין' },
        },
        selectedPhone: {
          required: { value: true, error: 'יש לבחור מספר טלפון' },
        },
      },
    },
  },

  reducers: {
    setSelectedPhone: {
      reducer(state, action) {
        state.form.selectedPhone = action.payload.selectedPhone;
        state.form.isPrettyNum = action.payload.isPrettyNum;
      },
    },
    reportAnalytics: (state, action) => { },

    initValidation: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    addAttempt: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        form.numOfAttempts = form.numOfAttempts + 1;
        return { payload: form };
      },
    },
    initData: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload.form);

        form.currentPhone = '';
        form.selectedPhone = '';
        form.newPhones = [];
        form.newPrettyPhones = [];
        form.hstPhone = '';

        return { payload: form };
      },
    },
    setIsExistPhone: {
      reducer(state, action) {
        state.form.isExistPhone = action.payload.isExistPhone;
      },
    },
    setIsSelectedOption: {
      reducer(state, action) {
        state.form.isSelectedOption = action.payload.isSelectedOption;
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const { maxLength, value, name } = payload.target;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);

        if (form.currentPhone == '') {
          let existError = document.querySelector('.error-container');
          if (existError != undefined) existError.innerHTML = '';
        }

        if (form.currentPhone.length > 10) {
          form.currentPhone = form.currentPhone.slice(0, 10);
          form.errors.currentPhone = '';
        }

        return { payload: validate };
      },
    },
    validateNewPhones: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        const validateForm = validateField(form, 'selectedPhone', form.selectedPhone);

        if (validateForm.errors['selectedPhone'] != '' && validateForm.errors['selectedPhone'] != undefined) validateForm['valid'] = false;
        else validateForm['valid'] = true;

        return { payload: validateForm };
      },
    },
    validateExistPhone: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload.form);
        let validateForm = form;

        const isExistInList = payload.selectedProducts.find((product) => product.existPhone == payload.form.currentPhone);
        if (!isExistInList) {
          validateForm = validateField(form, 'currentPhone', form.currentPhone);

          if (validateForm.errors['currentPhone'] != '' && validateForm.errors['currentPhone'] != undefined) validateForm['valid'] = false;
          else validateForm['valid'] = true;
        } else {
          validateForm.errors.currentPhone = 'המספר שהזנתם כבר מחכה לניוד. שננסה מספר אחר?';
          validateForm.valid = false;
        }

        return { payload: validateForm };
      },
    },
  },
  extraReducers: {
    [getPhoneNumbers.fulfilled]: (state, action) => {
      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
        return;
      }

      if (action.payload.errorCode) {
        let errorCode = 0;
        if (action.payload.errorCode == 1632) {
          errorCode = 32;
        }
        if (action.payload.errorCode == 1633) {
          errorCode = 33;
        }
        state.form.errorObj = { errorId: errorCode, message: action.payload.returnCodeMessage };
        return;
      }

      if (state.form.isExistPhone) {
        let uniqePhone = '';

        if (state.form.prevHstPhones.length == 0) {
          uniqePhone = action.payload.regularPhoneNumbersList[0];
          state.form.prevHstPhones.push(uniqePhone);
        } else {
          uniqePhone = getUniqePhoneNumber(state.form.prevHstPhones, action.payload.regularPhoneNumbersList); //TODO: change
          state.form.prevHstPhones.push(uniqePhone);
        }

        if (uniqePhone != '') {
          state.form.hstPhone = uniqePhone;
          state.form.newPhones = [uniqePhone];
        } else {
          state.form.errorObj = { errorId: 0, message: 'לא נמצא טלפון' };
        }
      } else {
        state.form.newPhones = action.payload.regularPhoneNumbersList;
        state.form.newPrettyPhones = action.payload.prettyPhoneNumbersList;
        state.selectedPhone = '';
      }
    },
  },
});

export const {
  changeHandler,
  setSelectedPhone,
  setIsExistPhone,
  setIsSelectedOption,
  initData,
  addAttempt,
  validateExistPhone,
  validateNewPhones,
  initValidation,
  reportAnalytics,
  setPrettyNumData,
} = ChoseNewOrExistingCellNumSlice.actions;

export default ChoseNewOrExistingCellNumSlice.reducer;
